export default __webpack_public_path__ + "8af68b9b8a399d4a0452313778c25a31.png";